<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>RTC Mismatch</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                    <b-button variant="dark" pill  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col>
								<b-form inline>
									<b-form-group>
										<label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
										<b-form-select class="mr-sm-2" v-model="selectedItem.state" :options="$root.state_options" size="sm" @change="selectedItem.ulb=0" required></b-form-select>
									</b-form-group>
									<b-form-group>
										<label for="inline-form-input-name" class="mr-sm-2 justify-left">ULB: </label>
										<b-form-select v-model="selectedItem.ulb" :disabled="selectedItem.state == ''" :options="ulb_options" size="sm" @change="fetchRTCreport()" required>
											<b-form-select-option value="0">All</b-form-select-option>
											<b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
								</b-form>
							</b-col>
						</b-row>
						<b-row class="mt-4 px-3" v-if="records.length > 0">
							<b-col lg="3">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="6">
							</b-col>
							<b-col lg="3">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3" v-if="records.length > 0">
							<b-col lg="12">
								<b-table show-empty small striped responsive outlined id="my-table" sticky-header="true" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" @filtered="onFiltered">
									<template #head()="scope">
										<div class="text-nowrap">
											{{ scope.label }}
										</div>
									</template>
									<template v-slot:cell(ulb_id)="row">
										<b-label>{{getUlbLabel(row.value)[0].title}}</b-label>
									</template>
                                    <template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3" v-if="records.length > 0">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Wards',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
        this.loadzones();
		//this.initload();
	},
	data() {
		var self = this;
		return{
			loading: false, 
			email: '',
			password: '',
            zonesUrl: self.$session.get('apiurl')+'moradabadapi/zone-list',
			recordUrl: self.$session.get('apiurl')+'moradabadapi/zones',
			rtcUrl: self.$session.get('apiurl')+'moradabadapi/rtc-mismatch',
            zones: [],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			ulb_options: [],
			fields: [
				{ key: 'feeder_pillar_no', label: 'FP No.' },
				{ key: 'location', label: 'Location' },
                { key: 'imei_no', label: 'IMEI' },
                { key: 'mobile_no', label: 'Mobile' },
                { key: 'no_of_fittings', label: 'No of Lights' },
                { key: 'insert_time', label: 'Installation' },
                { key: 'data_stamp', label: 'Data Stamp' },
                { key: 'update_time', label: 'Update Time' },
                { key: 'rtc_diff', label: 'RTC Diff' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
                ulb_id: '',
				title: '',
				areacode: '',
				status: 0
			}
		};
	},
	methods: {
        getUlbLabel: function(value){
            return this.zones.filter(function (item) {
				return item.id  == value;
			})
        },
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state  == self.selectedItem.state;
			})
		},
        fetchRTCreport(){
            var self = this;

            this.loading = true;
            
            self.axios.post(this.rtcUrl, {
				accesskey: self.$session.get('access_key'),
				ulb: self.selectedItem.ulb
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.records;

                    self.totalRows = self.records.length;
				}
                self.loading = false;
			})
			.catch(function (error) {
				alert(error);
			});
        },
		
        loadzones(){
            var self = this;
            
            self.axios.post(self.zonesUrl, {
                accesskey: self.$session.get('access_key')
            })
            .then(function (response) {
                if(response.data.error == 0 || response.data.error == '0'){
                    self.zones = response.data.result;
                }
            })
            .catch(function (error) {
                alert(error);
            });
        },
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;

					/*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
					self.zoneOptions = [];
					self.records.forEach(function(item){
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
					});
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
            if(self.selectedItem.ulb == 0){
                link.setAttribute("download", self.selectedItem.state+"-rtc-report.csv");
            }else{
                link.setAttribute("download", self.getUlbLabel(self.selectedItem.ulb)[0].title.replaceAll(' ','-').toLowerCase()+"-rtc-report.csv");
            }
			
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>